export default {
    payment_failed_please_contact_admin: 'Su pago no pudo ser procesado. Por favor, póngase en contacto con el soporte.',
    login: "Log InIniciar sesión",
    forgot_password: "¿Olvidaste tu contraseña?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "No hay más imágenes para moderar. Vuelve un poco más tarde. Gracias por tu ayuda 😘",
    timezone: 'Zona horaria',
    timezone_type_automatic: 'Su zona horaria se detectará automáticamente',
    timezone_type_manually: 'Su zona horaria elegida quedará bloqueada',
    invalid_token_message: 'Por motivos de seguridad, su token de acceso ha caducado.\n' +
        'Por favor, solicite un nuevo token para continuar.',
    try_again:'Intentar de nuevo',
    add_links_to_profiles_events_clubs:'Añade enlaces a perfiles, eventos y clubes',
    you_can_add_only_twenty_links: 'Solo puedes añadir 20 enlaces',
    enter_your_social_network_handle: 'Ingresa tu usuario de {social_network}',
    follow: 'Seguir',
    message: 'Message',
    message_copied: 'Copiado con éxito',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "responder",
    copy: "copiar",
    delete_for_all: "eliminar para todos",
    now: "¡AHORA!",
    meet_now:"¡Reúnete AHORA!",
    activate_meet_now: "Activa \"¡AHORA!\" y muestra que estás listo/a para reunirte.",
    activate_now:"Activa ¡AHORA!",
    deactivate_now:"Desactiva ¡AHORA!",
    meet_now_mini_text:"„¡AHORA!” se mantiene activo durante 30 minutos.",
    finished:"¿Terminado?",
    over_now:"...terminado ¡AHORA!",
    headline_or_nickname:"Título o Apodo",
    meet_now_upgrade_to_pro:"„¡AHORA!” se ha activado {0} veces hoy. Hazte PRO para reactivar „¡AHORA!” sin límites.",
    activate_meet_now_n_times:"Activa \"¡AHORA!\" hasta {0} veces al día. Los miembros PRO pueden activar sin límites.",

    email: "E-mail",
    email_or_username: "E-mail o Apodo",
    photo: "Foto",
    password: "tu contraseña",
    verify_age: 'Verificación de edad',
    verifying_age: 'Verificando edad',
    verification_success_title: 'Verificación completa',
    verification_success_desc: 'Tu edad ha sido verificada exitosamente.',
    verification_failed_title: 'Verificación fallida',
    verification_failed_desc: 'No se pasó la verificación. Puedes intentarlo de nuevo seleccionando o subiendo una foto diferente.',
    verification_limit_title: 'Límite Alcanzado',
    verification_limit_desc: 'Has superado el número máximo de intentos de verificación de edad. Por favor, inténtalo de nuevo más tarde.',
    try_again_in: 'Inténtalo de nuevo en',
    close: 'Cerrar',
    okay: 'Aceptar',
    start_verification: 'Iniciar verificación',
    choose_photo: 'Elegir foto',
    age_verification_photo_instruction: 'Por favor, proporcione una foto donde su rostro sea claramente visible. La foto debe contener solo a una persona.',
    age_verification_description: 'Para verificar tu edad, sigue las instrucciones.',
    verify_now: 'Verificar ahora',
    stay_logged_in: "¿Permanecer conectado?,",
    new_to_barebuddy: "¿Nuevo en Buddy?,",
    join_now: "¡Únete!",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Recuperar contraseña",
    reset_password: "Restablecer contraseña",
    confirm_password: "Confirmar Contraseña",
    recover_now: "Recuperar ahora",
    create: "Crear",
    age_modal:{
        'age_check' : 'Verificación de edad',
        'contain_sensitive_material':'Esta página puede contener contenido sensible.',
        'you_need_eighteen':'Tienes que tener más de 18 años para continuar.',
    },
    passwords: {
        password: "La contraseña deben tener al menos seis caracteres y coincidir con la confirmación de la contraseña",
        reset: "¡Tu contraseña ha sido restablecida!",
        sent: "Si este correo electrónico está registrado, recibirás un enlace de recuperación.",
        token: "Enlace de restablecimiento de contraseña inválido.",
        user: "Si este correo electrónico está registrado, recibirás un enlace de recuperación.",
     },
    join_modal:{
        become_a_member: "Hazte miembro ahora y disfruta de todas las funciones.",
        its_quick_and_free: "¡Es rápido y gratis!",
        already_a_member:"¿Ya eres miembro?",
    },
    welcome: {
        what_next: "¿Qué te gustaría hacer a continuación?",
        nickname: "Apodo",
        nickname_description: "Completa tu perfil ahora.",
        discover: "¡Descubre BUDDY",
        discover_description: "Charla, ten citas, relájate, guía y mucho más por descubrir.",
        pro: "Actualízate a Pro",
        pro_description: "Diversión infinita con la versión Pro."
    },
    invalid_credentials: "The user credentials were incorrect.",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: "Listo",
        automatic_location: "Ubicación automática",
        manual_location: "Ubicación manual",
        location_defining: "Definición de ubicación...",
        choose_password: 'Elige una contraseña',
        password_looks_good: "Tu contraseña se ve bien.",
        pick_nickname: "Escribe un apodo para tu perfil de Buddy.",
        pick_handle: "Este es tu enlace de Buddy:",
        suggestions: 'Sugerencias',
        handle_available: "El enlace de Buddy está disponible.",
        upload_photo: "Subir foto",
        handle_already_taken : "Este enlace de Buddy ya está tomado.",
        password_description: "su contraseña debe ser mínima. 6 caracteres de largo",
        handle_description : "Tu enlace de Buddy ayuda a otros a encontrar tu perfil. Puedes cambiarlo ahora o más tarde en la configuración.",
        nickname: "Apodo",
        birthdate: "Fecha de nacimiento",
        next: "Continuar",
        enter_email_address: "Tu correo electrónico",
        almost_finished: "Casi listo...",
        add_photo_text: "Añade una foto para que te vean los buddies.",
        i_am_ready: "Estoy listo",
        skip: "Saltar",
        back: "ATRÁS",
        add_photo: "Añadir foto",
        you_made_it: "¡Lo lograste!",
        accept_terms_privacy_text: "Al pulsar \"Continuar\" aseguro que soy mayor de 18 años y que he leído la {0} y aceptado las {1}.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Condiciones de uso",
        privacy_policy: "Política de privacidad",
        finish: "Finalizar",
        cancel: "Cancelar",
        upload: "Subir",
        welcome_to_bb: "Bienvenido a BUDDYY",
        where_are_you_located: "Dónde te encuentras?",
        use_current_location: "Usar mi ubicación actual",
        choose_location_manually: "Elegir ubicación manualmente",
        lets_go: "Listo",
        human_verification_required: "Por favor completa el cuadro Captcha para continuar",
        try_another_photo: "prueba con otra foto",
        map: "Mapa",
        use_gps: "Usar GPS",
        gps: "GPS",
        type_address: "Escribe tu dirección",
    },
    links: {
        about_us: "Sobre nosotros",
        imprint: "Imprimir",
        support: "Ayuda",
        terms: "Condiciones de uso",
        community_guidelines: "Pautas de la comunidad",
        privacy: "Declaracion de Privacidad",
        billing_support: "Soporte de Facturación",
    },
    profile_preview: 'Vista previa del perfil',
    public_gallery: 'Galería pública',
    nearby: "Cerca",
    recent: "Reciente",
    shuffle: "Shuffle",
    favorites: "Favoritos",
    favorites_online: "Favoritos en línea",
    online: "En línea",
    send_photo: "Enviar foto",
    send_location: "Enviar Ubicación",
    set_location: "Establecer Ubicación",
    type_something: "Escribe algo...",
    all: "Todo",
    unread: "No leído",
    pos_of_total: "{posición} de {total}",
    block_user: "Bloquear usuario",
    report_user: "Reportar usuario",
    user_not_found: 'Usuario no encontrado',
    cancel: "Cancelar",
    online_now: "En línea ahora",
    away: "En linea hace poco",
    offline: "Ausente",
    about: "Acerca de",
    height: "Altura",
    weight: "Peso",
    body: "Cuerpo",
    position: "Posición",
    penis: "Polla",
    hiv: "Estado",
    drugs: "Candy",
    info: "Info",
    stats: "Perfil",
    photos: "Fotos",
    settings: "Configuración",
    share: "Cuota",

    open_mailbox: 'Abrir el buzón',

    about_me: "Sobre mí",
    tags: "Tags",
    access: "Acceso",
    profile_account: "Cuenta",
    account: "Cuenta",
    logout: "Cerrar sesión",
    preferences: "Preferencias",
    show_age: "Mostrar edad",
    yes: "Sí",
    no: "No",
    join: "Únete",
    host: "Anfitrión",
    member: "Miembro",
    language: "Idioma",
    unit_system: "Sistema de unidad",
    metric: "Métrico",
    imperial: "Imperial",
    website_design: "Diseño del sitio web",
    old: "Antiguo",
    reset: "Reiniciar",
    unblock_users: "Desbloquear usuarios",
    delete_my_profile: "Eliminar mi perfil",
    your_profile_picture: "Foto de perfil",
    public_pictures: "Fotos públicas",
    can_select_count: "{count} / {total}",
    make_photo_private: "Hacer privada la foto",
    make_photo_public: "Hacer pública la foto",
    set_profile_picture: "Establecer como foto de perfil",
    delete_photo: "Eliminar foto",
    display_name: "Apodo",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Ubicación",
    support: "Ayuda",
    photo_message: "Mensaje de foto",
    distance_away: "{distance} de distancia",
    set_current_location: "Establecer ubicación actual",
    location_message: "Mensaje de ubicación",
    no_users_around: "No hay Buddies alrededor",
    no_more_users_around: "No hay más Buddies alrededor",
    to_see_members_become_a_member: 'Para ver más usuarios, hazte miembro.',
    no_chat_messages: "Historial de chat vacíoy",
    no_more_chat_messages: "No hay más mensajes en el historial de chat",
    message_not_delivered: "no se ha entregado - toca para volver a enviar",
    old_password: "Contraseña anterior",
    new_password: "Nueva contraseña",
    new_password_confirmation: "Repetir contraseña",
    password_modified: "Tu contraseña fue modificada con éxito",
    wrong_old_password: "Contraseña antigua incorrecta",
    save: "Guardar",
    are_you_sure_delete_profile: "¿Seguro deseas eliminar tu perfil?",
    all_users_unblocked: "Todos los usuarios fueron desbloqueado correctamente",
    no_tags: "agrega tags aquí",
    add_tag: "escribe un solo tag y presiona Volver",
    link_copied: "Enlace copiado",

    write_us_help: "Escríbenos para obtener ayuda, sugerencias y más",
    automatic_location: "Detección automática",
    manual_location: "Establecer ubicación manual",
    address: "Dirección",
    fail_load_location: "No pudimos acceder a tu ubicación. ¿Te gustaría indicar tu ubicación manualmente",
    fail_auto_choose_manual_location: "No pudimos acceder a tu ubicación. Elige tu ubicación manualmente.",
    this_is_profile_picture: "Esta es tu foto de perfil",
    sure_delete_conversation: "¿Eliminar el historial de conversaciones??",
    failed_load_user: "Error al cargar el perfil de usuario",
    please_register: "Por favor regístrate",
    recover_it: "Recuperar contraseña", //we talk here about forgotten 'password' on login form
    not_a_member: "¿No eres miembro todavía?",
    fail_block_user: "No se pudo bloquear al usuario",
    user_reported_confirmation: "Gracias por reportar al usuario. Revisaremos lo antes posible ",
    register_here: "Regístrate aquí",
    options: {
        body: {
            slim: "Delgado",
            average: "Promedio",
            athletic: "Atlético",
            muscular: "Musculoso",
            stocky: "Grueso"
        },
        position: {
            top: "Activo",
            more_top: "Más top",
            bottom: "Pasivo",
            more_bottom: "Más Pasivo",
            versatile: "Versátil"
        },
        hiv: {
            positive: "Positivo",
            negative: "Negativo",
            undetectable: "Indetectable",
            prep: "PrEP",
            unknown: "Desconocido"
        },
        drugs: {
            yes: "Sí",
            no: "No",
            socially: "A veces",
        }
    },
    Sunday: "Domingo",
    Monday: "Lunes",
    Tuesday: "Martes",
    Wednesday: "Miércoles",
    Thursday: "Jueves",
    Friday: "Viernes",
    Saturday: "Sábado",
    January: "Enero",
    February: "Febrero",
    March: "Marzo",
    April: "Abril",
    May: "Mayo",
    June: "Junio",
    July: "Julio",
    August: "Agosto",
    September: "September",
    October: "Octubre",
    November: "Noviembre",
    December: "Diciembre",
    back: "Atrás",
    report_harassment: "Acoso",
    report_fake: "Fake",
    report_spam: "Spam",
    report_under_age: "Menor de edad",
    report_other: "Otro",
    cookies_message: "Las cookies nos ayudan a ofrecer nuestros servicios. Al utilizar nuestros servicios, acepta nuestro uso de cookies.",
    learn_more: "Aprende más",
    profile_is_deleted: "Este perfil fue eliminado",
    crop_photo: "Editar foto",
    install_pwa_ios_message: "Instala BUDDY en tu teléfono: <img src=\"/assets/img/iphone-share-btn.jpg\" style=\"height: 26px\" /> and then <strong>Add to Home Screen</strong>: <img style=\"height: 30px\" src=\"/assets/img/add-home-screen-en.png\" />",
    you_are_offline: "Parece que estás sin conexión",
    show_map: "Mapa",
    subscribe_to_newsletter: "Boletin informativo",
    emails_reminders: "Resumen de correo electrónico",
    daily: "Diario",
    weekly: "Semanal",
    monthly: "Mensual",
    never: "Nunca",
    "validation.imageable": "Tipo de imagen no admitido. Carga solo imágenes JPG, PNG o GIF. ",
    user_blocked_confirmation: "Usuario bloqueado",
    search_users: "Apodo",
    sure_delete_event: "¿Eliminar este evento?",

    home: {
        come_inside: 'Entra',
        content_removal : "Eliminación de contenido",
        bad_boys_society: "Bad Boys Society",
        create_account: "Crear cuenta",
        tagline: "BUDDY",
        fun: "Construyendo una mejor app gay",
        login: "E-mail o apodo",
        password: "Contraseña",
        log_in: "Iniciar sesión",
        remember_me: "Recordarme.",
        forgot_password: "¿Olvidaste tu contraseña?",
        new_here: "¿Nuevo aquí?",
        sign_up: "Regístrate",

        wants: "Muestra tu lado kinky.",
        wants_desc: "Con experiencia o curiosidad: forma parte de la comunidad BUDDY y explora tus kinks. Envía toques y comienza a chatear al instante. Busca hashtags para encontrar rápidamente kinksters que coincidan contigo.<br><br>Citas kinkys más rápido que nunca.",

        videos: "Mira y comparte videos",
        videos_desc: "Mira un montón de videos hot de los miembros. Comparte tus videos pregrabados en chats privados o muéstralos en tu perfil público.<br><br>Nunca antes fue tan divertido.",

        calendar: "Diviértanse juntos.",
        calendar_desc: "Crea anuncios privados en nuestro calendario. Muestra a otros amigos lo que quieres y cuándo lo quieres. ¿Buscas algo más? Organiza grupos y encuentra nuevos amigos.<br><br>Conoce a kinksters como tú. ",

        everywhere: "Entonces... ¿cuál es tu kink?",
        everywhere_desc: "Utiliza nuestro sitio web sin censura o descarga la aplicación BUDDY.<br><br>¡Únete ahora y pruébala!",
        
        generation: "Bienvenido a Buddyverse",
        generation_desc: "Creemos que podemos servir mejor a nuestra comunidad haciendo que BUDDY sea accesible para todos. A diferencia de otras aplicaciones, ofrecemos las funciones más útiles totalmente gratis. Sin límites, sin anuncios molestos. Queremos convertirnos en la mejor y más grande app gay para el estilo de vida kinky y fetichista. Únete ahora y corre la voz.<br><br>¡Más buddies, más diversión!",

        sign_up_now: "Únete",

        company: "Empresa",
        about_us: "Sobre nosotros",
        blog: "Blog",
        help: "Ayuda",
        support: "Soporte de facturación",

        legal: "Legal",
        privacy: "Declaracion de Privacidad",
        terms: "Condiciones de Uso",
        community_guidelines: "Pautas de la comunidad",
        usc: "18 U.S.C.2257",
        imprint: "Imprimir",

        languages: "Idiomas",
        follow_us: "Síguenos"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun.",
    },

    company: "Empresa",
    legal: "Legal",
    community_guidelines: "Pautas de la comunidad",
    social_media: "Redes Sociales",
    edit_your_photo: "¡Eres preciosa!",
    complete_profile: "Completar mi perfil",
    add_more_photos: "Agregar más fotos",
    check_out_guys: "Ver Buddies",
    members_login: "Iniciar sesión para Miembros",
    change_password: "cambiar contraseña",
    create_your_event_plus: "Crea tu propio evento. Haz clic en +",
    create_new_event: "Crear un nuevo evento",
    create_event: "Rear evento",
    create_your_club_plus: "Crea tu propio club. Haz clic en +",
    create_new_club: "Crear un nuevo club",
    create_club: "Crear un club",
    title: "Título",
    date: "Fecha",
    time: "Hora",
    add_event_details: "Agrega algunos detalles",
    event_description: "Descripción del evento",
    club_description: 'Descripción',
    club_description_placeholder: '¿De qué se trata tu club?',
    joined_to_club: "se ha unido",
    left_to_club: "se fue",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Agregar etiquetas (opcional)",
    select_address: "Seleccionar dirección",
    location_details: "Detalles de ubicación (opcional)",
    location_example: "(eg: my flat, venue name)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Elige imágenes para tu evento",
    club_choose_photos: 'Elige imágenes para tu club',
    display: "Mostrar:",
    alternative: '',
    hot: "foto sexy (opcional)",
    preview: 'imagen segura',
    for_censored_app: "para aplicación censurada",
    visible_only_uncensored_website: "visible solo en el sitio web sin censura",
    preview_picture: "Visualizar Foto",
    submit_event: "Enviar",
    event_address: "Dirección del Evento",
    club_address: 'Ciudad',
    please_select_preview_picture: "Seleccione la imagen de vista previa",
    set_preview_picture: "Establecer como imagen de vista previa",
    event_successfully_added: "Tu evento se ha añadido correctamente",
    event_successfully_updated: "Tu evento se ha actualizado correctamente.",
    no_events_around: "No hay eventos cercanos",
    no_more_event_around: "No hay más eventos cercanos",
    club_successfully_added: 'Tu club se ha añadido correctamente',
    no_clubs_around: 'No hay clubs cercanos',
    no_more_club_around: 'No hay más clubs cercanos',
    edit: "Editar",
    recipient_will_not_see_you: "El destinatario no verá tu perfil real.",
    public_videos: "Vídeos públicos",
    send: "Enviar",
    event_choose_videos: "Elige videos para tu evento",
    delete_video: "Eliminar video",
    add_video: "Añadir video",
    videos: "Videos",
    play_video: "Reproduce el video",
    video_uploaded_processing: "Tu video se subió correctamente y se está procesando. Te notificaremos cuando esté listo.",
    video_processed: "Tu video está listo para usarse",
    video_message: "Mensaje de video",
    sure_delete_photo: "¿Eliminar esta foto?",
    sure_delete_video: "¿Eliminar este video?",
    too_hot: "Demasiado caliente",
    notifications: "Notificaciones",
    push_notifications: "Notificaciones push",
    help: "Ayuda",
    profile: "Perfil",
    user_blocked: "Has bloqueado a este usuario o él te ha bloqueado a ti.",
    open_blocked_users: "Abrir lista de usuarios bloqueados",
    faq: "PREGUNTAS MÁS FRECUENTES",
    support_chat: "Chat de soporte",
    click_here_tutorials: "Haz clic aquí para ver tutoriales",
    send_direct_message: "Envíanos un mensaje directo",
    app: "App",
    security: "Seguridad",
    notification_sound: "Sonido de notificación",
    deactivate_my_profile: "Desactivar mi perfil",
    deactivate_or_delete_my_profile: "Desactivar o eliminar mi perfil",
    customize_sharing_links: "Personalizar enlaces para compartir",
    delete_all_sharing_links: "Eliminar todos los enlaces para compartir",
    delete_all: "Eliminar todos",
    deactivate_account: "Desactivar Cuenta",
    taking_break_buddy: "¿Quieres salir un rato de BUDDY?",
    deactivate_text_description: "Desactiva tu perfil y desaparece por completo del radar y búsqueda",
    deactivate: "Desactivar",
    delete_profile_text: "Si quieres dejar BUDDY para siempre, {0} para eliminar tu perfil. Es permanente, no se puede deshacer y tendrás que crear un nuevo perfil cuando quieras volver. Recuerda, todos necesitan un BUDDY",
    click_here: "haz clic aquí",
    are_you_sure_deactivate_profile: "¿Seguro quieres desactivar tu perfil?",
    inactive_profile: "Perfil inactivo",
    account_is_deactivated: "Tu perfil adorable de BUDDY está desactivado. <br /> Haz clic en \"Activar\" para volver.",
    activate: "Activar",
    leave: "Salir",
    profile_is_deactivated: "Perfil actualmente desactivado",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Tu configuración multimedia está establecida para advertirte sobre contenido sensible. <br /> <br /> Para ver, debes cambiar tu selección en la configuración de seguridad",
    change_settings: "Cambiar ajustes",
    show_more: "Mostrar más..",
    display_sensitive_events: "Mostrar Eventos sensibles",
    display_sensitive_media: "Mostrar Multimedia sensibles",
    tiles: "Mosaicos",
    list: "Lista",
    filter: "Filter",
    pics: "Fotos",
    age: "Edad",
    new: "Nuevo",
    ok: "OK",
    taps: "Toques",
    visitors: "Visitantes",
    visited: "Vistos",
    no_visitors: "No hay visitantes todavía",
    no_more_visitors: "Sin más visitantes",
    no_visited: "Sin visitas todavía",
    no_more_visited: "No más visitasNo más visitas",
    no_taps: "Sin toques",
    no_more_taps: "No más toques",

    discreet_mode: "Invisible",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Ocultar perfil por completo",
    upgrade_to_pro: "Actualizar a PRO",
    upgrade_to: "Actualizar a",
    upgrade_now: "Actualizar ahora",
    upgrade: "Actualizar",
    click_here_to_upgrade: "Haz clic aquí para actualizar",
    click_here_to_cancel: "Haz clic aquí para cancelar",
    pro: "PRO",
    cancel_pro: "Cancelar PRO",
    thank_you_for_being_a_pro: "Gracias por ser un Buddy PRO",
    successful_pro_upgrade: "You are now a PRO Buddy!",
    failed_pro_upgrade: "Oops... Something went wrong",
    we_hope_you_enjoyed_pro: "Esperamos que hayas disfrutado de Buddy PRO",

    delete_this_message: "¿Eliminar este mensaje?",
    delete: "Eliminar",
    removed: "quitado",

    pro_slides_1_title: "Invisible",
    pro_slides_1_description: "con Modo Máscara",
    pro_slides_2_title: "Cancelar mensajes",
    pro_slides_2_description: "y comprueba si ha leído <br> tu mensaje",
    pro_slides_3_title: "Más filtros",
    pro_slides_4_title: "Ilimitado",
    pro_slides_4_description: "favorites, blocks, visitors,<br>public pics & vidsfavoritos, bloqueos, visitantes, fotografías y vídeos públicos",
    pro_slides_5_title: "Más Diversión",
    pro_slides_5_description: "ver todos los videos y fotos",

    notifications_button: 'Activar notificaciones',
    splash_notifications_title: 'Mantente al día',
    splash_notifications_description: 'Por favor, activa las notificaciones para recibir mensajes и alertas de tus buddies',

    splash_blocks_title: "Bloqueos ilimitados",
    splash_blocks_description: "para bloqueos ilimitados actualizar a",
    splash_favorites_title: "Favoritos ilimitados",
    splash_favorites_description: "para una actualización ilimitada de favoritos a",
    splash_mask_title: "Invisible",
    splash_mask_description: "con actualización del Invisible a",
    splash_censored_title: "Ver más",
    splash_censored_description: "para actualización ilimitada de contenido a",
    splash_visitors_title: "Quién me vió",
    splash_visitors_description: "para ver a todos tus visitantes actualizar a",
    splash_filters_title: "Más filtros",
    splash_filters_description: "Para obtener más filtros, actualiza a",
    splash_media_title: "Imágenes y videos públicos ilimitados",
    splash_media_description: "para actualizar imágenes/videos ilimitados a",
    splash_deletemsg_title: "Eliminar un mensaje",
    splash_deletemsg_description: "para eliminar un mensaje, actualizar a",
    splash_change_settings_title: "Tu configuración multimedia está establecida para advertirte sobre contenido sensible.",
    splash_change_settings_description: "Para ver, debes cambiar tu selección en la configuración de seguridad.",
    splash_events_title: "Más eventos",
    splash_events_description: "Para más eventos, actualizar a",

    pro_upgrade_message_desktop: "Las suscripciones se renovarán automáticamente a menos que se cancelen dentro de las 24 horas anteriores al final del período actual. <br> Visita <a href=\"http://cs.segpay.com\"> SEGPAYEU.COM </a>, nuestro agente de ventas. <br> Los cargos aparecerán en el extracto de tu tarjeta de crédito como <a href=\"http://cs.segpay.com\"> SEGPAYEU.COM * BUDDY </a>.",
    pro_upgrade_message_mobile: "Las suscripciones se renovarán automáticamente a menos que se cancelen dentro de las 24 horas anteriores al final del período actual.",
    payment_blocked: "La solicitud de pago está en proceso.",
    you_cant_send_messages_to_this_user: "No puedes enviar mensajes a este usuario.",

    events: {
        report: {
            title: "Informar de un evento",
            wrong_type: "Categoría incorrecta",
            illegal: "Ilegal",
        },
        type: {
            friends: 'Friends',
            fun: 'Date',
            bang: 'Chill',
            guide: 'Guide',
            chemsfriendly: "chemsfriendly",
            required: "Por favor selecciona una categoría",
        },
        date: {
            today: "hoy dia",
            tomorrow: "mañana",
            pick_date: "fecha"
        },
        link_my_profile: "Vincular mi perfil",
        not_found: "Evento no encontrado",
        report_success: "Gracias por informar del evento. Lo revisaremos lo antes posible",
        new_event: "Nuevo evento",
        new_bang: "New bang",
        my_events: "Mis eventos",
        publish: "Publicar",
        select_type: '¿Qué tipo de evento te gustaría crear?',
        about_guide: "eventos públicos para todos (fiestas, festivales, comunidad)",
        about_fun: "encontrar un buddy para actividades privadas (1:1)",
        about_bang: "organizar eventos privados para grupos",
        invitation_only_event: "con invitación (evento privado)",
        please_add_favourite_buddies_first: "Añade primero a tus buddies favoritos",
        accept: "Aceptar",
        decline: "Declinar",
        invited: "Invitado",
        invite: "Invitar",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        more_clubs: 'Más clubes',
        hide_club_admin: "Ocultar administrador del club",
        report: {
            title: "Informar de un club",
            wrong_type: "Categoría incorrecta",
            illegal: "Ilegal",
        },
        type: {
            discover: 'Descubrir',
            my_clubs: 'Mis clubes',
            chemsfriendly: "chemsfriendly",
            required: "Por favor selecciona una categoría",
        },
        date: {
            today: "hoy dia",
            tomorrow: "mañana",
            pick_date: "fecha"
        },
        not_found: 'Club no encontrado',
        report_success: 'Gracias por informar el club. Lo revisaremos lo antes posible',
        new_club: 'Nuevo club',
        my_events: "Mis clubes",
        publish: "Publicar",
        invitation_only_club: "con invitación (club privado)",
        write_to_support_to_open_club: "Escribe a soporte si quieres cambiar la privacidad de este club",
        please_add_favourite_buddies_first: "Añade primero a tus buddies favoritos",
        accept: "Aceptar",
        decline: "Declinar",
        invited: "Invitado",
        invite: "Invitar",
    },

    payment: {
        coming_soon: "Próximamente",
        month: "por mes",
        one_month: "mes",
        three_months: "meses",
        twelve_months: "meses",
        your_promotion_code: "Tu código de promoción",
        please_select_payment_option: "Selecciona la opción de pago.",
        use_promo_code: "Use un código PROmo",
        credit_card: "Tarjeta de crédito",
        alternative_payments: "Pagos alternativos",
        renews_automatically_until_cancelled: "Renovación automática hasta cancelación.",
        active_until: "Your PRO-status is active until",
        one_time: "Una vez",
        no_need_to_cancel: "(¡No es necesario cancelar!)",
        upgrade: {
            one_month: "Actualizar por 1 mes",
            three_months: "Actualizar por 3 meses",
            twelve_months: "Actualizar por 12 meses",
        },
        upgrade_paypal: {
            one_month: "PayPal por 1 mes",
            three_months: "PayPal por 3 meses",
            twelve_months: "PayPal por 12 meses",
        },
        send:"Enviar",
        thank_you: "¡Gracias!",
        return_to_buddy: "Volver a BUDDY",
        paypal: {
            message: "<p>Por favor, ingresa tu dirección de correo electrónico de PayPal.</p><br /><p>Te enviaremos un enlace de PayPal a esa dirección.</p> <br /><p>Después de recibir el pago, mejoraremos tu perfil de Buddy.</p>",
            successMessage: "<p>Hemos recibido tu solicitud de mejora.</p><br /><p>Te enviaremos un enlace de PayPal en breve.<br /> Después de recibir el pago,<br/>por favor, permítenos un tiempo para realizar <br/>tu mejora.</p><br /><p>¡Lo hacemos a mano! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Desbloquear todos los filtros",
            be_invsble: "Estar invisible",
            see_all_who_viewed_me: "Ver a todos los que me han visto",
            remove_messages: "Eliminar mensajes",
            make_notes_on_profile: "Hacer notas en perfiles",
            unlimited_favorites: "Favoritos ilimitados",
            view_hot_medias: "Ver medios XXX en la aplicación",
            see_if_your_message_has_been_read: "Ver si tu mensaje ha sido leído",
            see_wh_marked_you_favorite: "Ver quién te ha marcado como favorito",
            hide_profile_visits: "Ocultar visitas al perfil"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: "La duración del video debe ser superior a 1 segundo.",
            highDuration: "La duración del video debe ser inferior a 15 min.",
        },
    },

    rush: {
        running_for_x_days: "Ejecutando durante {days} día (s)",
        stars_and_strips_upgrade: "Estrellas y strips. Actualizar a",
        announce: "<span> Hola, amigos: </span> <span> los constructores de amigos han creado algo nuevo para ti. </span> <span> {0} son pequeñas aplicaciones dentro de BUDDY, que son útiles y divertidas </span> <span> ¡Diviértete y mantente curioso! </span> ",
        how_to: {
            title: "RUSH - Cómo ...",
            create: "Crea tu strip",
            name: "Dale un nombre a tu strip",
            media: "Selecciona imagen o escribe un texto",
            publish: "Publica tu strip y agrega más contenido",
        },
        welcome: {
            title: "Bienvenido a RUSH",
            story: {
                title: "Tu propia historia.",
                description: "Agrega Fotos a tu strip y muéstralas a todos tus buddies.",
            },
            post: {
                title: "Publicar todos los días.",
                description: "Haz que el \"Rush\" dure más y recibe más aplausos.",
            },
            applause: {
                title: "¡¿Más aplausos ?!",
                description: "Te da un mosaico de vista previa más grande. ¡Eso significa más visitas de buddies! ",
            },
            attention: {
                title: "¡Atención!",
                description: "Si no hay una nueva foto dentro de las 24 horas, tu strip desaparece. Se acabó el 'Rush'.",
            },
        },
    },
    sure_unblock_user: "¿Desbloquear este perfil?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "¿Está seguro de que desea eliminar todos los enlaces para compartir?",
    all_links_will_be_deactivated: "Todos los enlaces serán desactivados.",
    all_sharing_links_deleted_successfully: "Todos los enlaces para compartir se eliminaron con éxito",
    this_is_your_sharing_code: "Este es tu enlace para compartir (haz clic para copiar)",
    share_your_selected_videos: "Comparte tus vídeos seleccionados con<br>los chicos que aún no están en Buddy.",
    send_via_whatsapp: "Comparte vía Whatsapp",
    tap_on_the_videos_you_want_to_share: "Pulsa sobre los vídeos que quieras compartir",
    cancel_share: "Cancelar",
    share_now: "Comparte",
    status:"Estado",
    you_need_to_be_a_pro_for_editing:"Necesitas ser un <strong>PRO</strong> para editar",
    expire_at_date:"Caducar en la fecha",
    expire_at_time:"Caducar en el tiempo",
    views_limit:"Límite de vistas",
    you_dont_have_any_links:"no tienes ningun enlace",
    link_settings_saved:"Configuración de enlace guardada",
    can_not_get_sharing_links:"No se pueden obtener enlaces para compartir",
    copied_to_clipboard: "copiado al portapapeles",
    share_whatsapp_test: "Aquí está el enlace a mi vídeo en buddy.net: ",
    share_videos: 'Compartir vídeos',
    accept_all: 'Aceptar todo',
    no_messages : 'Ningún mensaje',
    you : 'te',
    has: 'se ha',
    have: 'has',
    joined: 'unido',
    left: 'ido',
    web_push_notifications: 'Notificaciones push web',
    modal_pro_upgrade_description : 'Disfruta de ésta y otras muchas funciones si pasas a PRO.',
    modal_pro_visit_upgrade_description : 'Oculta tu visita a este perfil con PRO',
    note : 'Nota',
    note_textarea_placeholder : "Añadir información personal sobre este perfil...",
    who_marked_me_favorite : "Quien me marcó favorito",
    cancel_failed: "La cancelación falló, inténtalo de nuevo",
    subscription_canceled: "Suscripción cancelada",
    confirm_cancel: "¿Realmente desea cancelar la suscripción?",
    cancel_subscription: "Cancelar suscripción"
}
